export const PANELS_ACTIONS = {
  add: "PANELS/ADD",
  remove: "PANELS/REMOVE",
};
